import Button, {BtnColor} from "../../../components/Button/Button";
import {useDispatch, useSelector} from "react-redux";
import {onOrderActionClick} from "../../../store/Orders/actions";
import {useEffect, useState} from "react";
import PulseLoader from "react-spinners/PulseLoader";

const ListDetailsActions = ({ order_id, buttons }) => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false)

    const orderLoading = useSelector(state => state.orders.order_loading)

    useEffect(() => {
        if (!orderLoading) {
            setLoading(false)
        }
    }, [orderLoading])

    const actionOrder = (orderId, action) => {
        setLoading(true)
        dispatch(onOrderActionClick(orderId, action))
    }

    return (
        <div className="py-4 text-center mx-2" >
            {buttons.map(item => (
                <Button key={item.text}
                        className="w-full"
                        color={item.color}
                        onClick={() => actionOrder(order_id, item.action)}>
                    {loading ? (
                        <PulseLoader color="rgba(79, 70, 229, 1)" loading={loading}  size={5} />
                    ) : item.text }

                </Button>
            ) )}
        </div>
    )
}

export default ListDetailsActions;
